import { atom } from 'recoil';
export const inactiveTagToTerminate = atom({
  key: 'inactiveTagToTerminate',
  default: undefined
});